module.exports = __webpack_public_path__ + "static/media/huanjing4.fab0c05f.png";